import { useSelector } from 'react-redux';
import _ from 'lodash';

import * as api from '../../api';
import * as store from '../../reducers/store';
import {
  getMaybeFormSetSelectedTimeSlot,
  getMaybeSelectedEhrProviderWithPractice,
} from '../../utils/scheduling';

export const useBookedSlot = (
  page?: number,
): {
  selectedEhrProviderWithPractice: api.User.EhrProviderInformationPractice | null;
  selectedTimeSlot: store.SelectedEhrTimeSlot | null;
} => {
  const selectedTimeSlot = useSelector((state: store.All) => {
    if (state.inbound.selectedEhrTimeSlot) {
      return state.inbound.selectedEhrTimeSlot;
    }
    const { formSets, selectedFormSetId } = state;
    if (!selectedFormSetId || !formSets || !formSets[selectedFormSetId]) {
      return null;
    }
    const flattenForms = _.flatten(_.map(formSets[selectedFormSetId].forms));
    return getMaybeFormSetSelectedTimeSlot(
      _.flatten(flattenForms.map((form) => form.fields)),
      page,
    );
  }, _.isEqual);

  const selectedEhrProviderWithPractice = useSelector(
    (state: store.All) =>
      getMaybeSelectedEhrProviderWithPractice(
        state.inbound.ehrProviderInformation,
        selectedTimeSlot,
        state.inbound.selectedProviderId,
      ),
    _.isEqual,
  );

  return {
    selectedTimeSlot,
    selectedEhrProviderWithPractice,
  };
};
